import React from "react";

const WebHiClassInfoComposition = () => {

    return (
        <div className="d-flex flex-column w-100" style={{ margin: '10px 0px', wordBreak: 'keep-all', wordWrap: 'break-word' }}>
            <div className="d-flex justify-content-center align-items-center w-100" style={{ margin: '2rem 0' }}>
                <img className="w-100" src="/images/info/compo/composition.jpg" alt="" />
            </div>
        </div>
    );
}

export default WebHiClassInfoComposition;